import {
  FilterCondition,
  FilterOperator,
  PagedResultDTOOfParkerRegistrationWithParkerInfoDTO,
  ParkerRegistrationOffense,
  ParkerRegistrationType,
} from '../../base/models/models.swagger.generated';
import { ClientService } from '../../base/services/client/client.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterDTO, ParkerRegistrationClient, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ParkerOffenseFilterType } from 'src/app/base/models/parker-offense-filter-type.enum';
import { FilterUtil, LICENSE_PLATE_FIELDS } from 'src/app/base/shared/filter-util';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';

export const controlPlateField = 'ControlPlate';
export const countryCodeField = "CountryCode";
export const zoneNameField = 'RegisteredZoneName';
export const zoneDeviceNameField = 'RegisteredByZoneDeviceName';

@Injectable()
export class ParkerRegistrationService extends ShowInactiveService implements IAdaptorService {

  public offenseType: ParkerOffenseFilterType;
  public parkerName: string | null = null;
  public licensePlate: string | null = null;

  constructor(private parkerRegistrationClient: ParkerRegistrationClient,
              private clientService: ClientService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection):
          Observable<PagedResultDTOOfParkerRegistrationWithParkerInfoDTO> {
    if (!sortBy) {
      sortBy = 'RegistrationDateTime';
      sortDirection = SortDirection.Descending;
    } else if (sortBy === zoneDeviceNameField) {
      sortBy = 'RegisteredByZoneDevice.Name';
    } else if (sortBy === zoneNameField) {
      sortBy = 'RegisteredZone.Name';
    }

    this.adjustControlPlateFilters(filters);
    this.adjustCountryCodeFilters(filters);
    this.adjustZoneNameFilters(filters);
    this.adjustZoneDeviceNameFilters(filters);
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }
    FilterUtil.correctDateTimeFilters(filters, 'RegistrationDateTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    this.addFiltersByOffenseType(filters);
    FilterUtil.addParkerNameFilter(filters, this.parkerName);
    FilterUtil.addLicensePlateFilter(filters, this.licensePlate);

    return this.parkerRegistrationClient.searchRegistrations(this.clientService.selectedClient?.id, filters, skip, take, sortBy, sortDirection).pipe(
      map(result => {
        result?.items?.forEach(item => {
          (item as any)[controlPlateField] = item.knownTag
            ? item.knownTag.controlPlateNumber
            : item.unknownParkerTagControlPlateNumber;
          (item as any)[countryCodeField] = item.knownTag
            ? item.knownTag.countryCode
            : item.unknownParkerTagCountryCode;
        });
        return result;
      })
    );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private addFiltersByOffenseType(filters: FilterDTO[]): void {
      if (!filters.length) {
      filters = [];
    }
    
    if (this.offenseType === ParkerOffenseFilterType.Parker) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'Offense',
        operator: FilterOperator.NotEqual,
        value: ParkerRegistrationOffense.NoOffense.toString()
      }));
    } else if (this.offenseType === ParkerOffenseFilterType.Offense) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'PenaltyIssued',
        operator: FilterOperator.Equal,
        value: 'true'}));
    } else if (this.offenseType === ParkerOffenseFilterType.ParkingRangerEntry) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: 'Type',
        operator: FilterOperator.Equal,
        value: ParkerRegistrationType.ParkingRangerEntry.toString()
      }));
    }
  }

  private adjustControlPlateFilters(filters: FilterDTO[]): void {
    if (!filters) {
      filters = [];
    }
    FilterUtil.extendFiltersToMultiFieldFilter(filters, controlPlateField, LICENSE_PLATE_FIELDS, FilterCondition.Or);
  }

  private adjustCountryCodeFilters(filters: FilterDTO[]): void {
    if (!filters) {
      filters = [];
    }
    const countryCodeFilters = FilterUtil.FindAllFiltersWithSpecificField(countryCodeField, filters);
    const filterCondition = countryCodeFilters.length > 0 && countryCodeFilters[0].operator === FilterOperator.Empty
      ? FilterCondition.And
      : FilterCondition.Or;
    FilterUtil.extendFiltersToMultiFieldFilter(filters, countryCodeField, [
      "KnownTag.CountryCode",
      "UnknownParkerTagCountryCode",
    ], filterCondition);
  }

  private adjustZoneNameFilters(filters: FilterDTO[]): void {
    FilterUtil.replaceFieldNameInfilters(filters, zoneNameField, 'RegisteredZone.Name');
  }

  private adjustZoneDeviceNameFilters(filters: FilterDTO[]): void {
    FilterUtil.replaceFieldNameInfilters(filters, zoneDeviceNameField, 'RegisteredByZoneDevice.Name');
  }
}
